import {
  AttributeConfigurationDc,
  CompositeLayerConfigurationDc,
  CompositeLayerInfoDc,
  DetailedTableInfoDc,
  ExtendedProjectInfoDc,
  GeometryType,
  LayerDefinitionDc,
  PostgresLayerServiceConfigurationDc,
  ProxyServiceInfoDc,
  ServiceConfigurationBaseDc,
  ServiceInfoDc,
  TableInfoDc,
} from "@evergis/api";

import { StyleProxy } from "../evergis/core/classification/StyleProxy";
import { isObject } from "../utils/isObject";
import { PostgresLayerService } from "./service";
import { TmsType } from "../components/Dialogs/AddTmsService/types";

// referenced to AttributesConfigurationDc
interface AttributeConfigurationParams {
  idAttribute: string;
  titleAttribute?: string;
  geometryAttribute: string;
  layerAttributes?: AttributeConfigurationDc[];
  tableName?: string;
}

type PostgresLayerServiceConfigurationParams = Pick<PostgresLayerServiceConfigurationDc, "acl" | "condition">;

export type ProjectInfo = Partial<ExtendedProjectInfoDc> & {
  layersCount?: number;
};

export interface LayerInfo
  extends Partial<AttributeConfigurationParams>,
    Partial<Omit<PostgresLayerService, "style">>,
    Partial<PostgresLayerServiceConfigurationParams> {
  style?: StyleProxy;
  sr?: LayerDefinitionDc["spatialReference"];
  name?: string;
  type?: string;
  proxy?: ProxyServiceInfo;
  copyrightText?: string;
  sourceType?: TmsType;
}

export type ProxyServiceInfo = Required<Omit<ProxyServiceInfoDc, keyof ServiceInfoDc>>;

// FIXME: https://jr.everpoint.ru/browse/PUB-2350
export type LayerType = CompositeLayerInfoDc["layer"];
// FIXME: https://jr.everpoint.ru/browse/PUB-2350
export type ServiceConfiguration = ServiceInfoDc["configuration"];

export type TableInfoExtended = {
  objectsCount: TableInfoDc["rowCount"];
  geometryType: GeometryType;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TableInfo extends Partial<DetailedTableInfoDc & TableInfoExtended> {}

export const isLayerService = (value?: unknown): value is LayerType => isObject(value) && "name" in value;

export const isServiceConfiguration = (value?: unknown): value is ServiceConfiguration => isObject(value);

export const isServiceConfigurationBase = (value?: unknown): value is ServiceConfigurationBaseDc =>
  isServiceConfiguration(value) && "name" in value;

export const isCompositeLayerConfiguration = (value?: unknown): value is CompositeLayerConfigurationDc =>
  isObject(value) && "name" in value;

export const isProxyService = (value?: unknown): value is ProxyServiceInfoDc =>
  isLayerService(value) && ("sourceType" in value || (value as ProxyServiceInfoDc).type === "RemoteTileService");
